import React from "react"
import { WingsButton } from "@wingspans-ui"
import { FormattedMessage } from "react-intl"

const bookDemoLink = "https://calendly.com/wingspans/15-minute-meeting-with-wingspans-lindsay-kuhn?month=2026-09"

/**
 * Opens a calendly link for booking a demo. Wrapper around WingsButton.
 * @param {string} section - identifies the button for google analytics
 * @returns 
 */
const BookDemoButton = ({ variant, size, section="", ...props}) => {
  const visitBookDemoPage = (e) => {
    e.preventDefault()
    if (!window) {
      return
    }
    window.open(bookDemoLink, "_blank")
  }
  return (
    <WingsButton
      variant={variant || "primary"}
      size={size || "small"}
      data-gtm={`book-a-demo-${section}`}
      onClick={visitBookDemoPage}
      {...props}
    >
      <FormattedMessage id="book-a-demo" defaultMessage="Book a Demo" />
    </WingsButton>
  )
}

export default BookDemoButton
